import { connectColors, themeColors } from '@/theme/colors';
import { Table } from '@lego/connect-components-react';
import { Flex, Text } from '@lego/klik-ui';
import type {
  KeyFigureField,
  KeyfiguresColumn,
} from './keyfigures-view-helpers';

type KeyFigure = {
  label: string;
  field: KeyFigureField;
};

const getKeyFigures = (currency: string): KeyFigure[] => [
  { label: 'LL RRP Index', field: 'rrpIndex' },
  { label: 'Retail Margin %', field: 'rm' },
  { label: 'LL List Price Index', field: 'lpLocalLeadIndex' },
  { label: 'LL NIP Index', field: 'nipLocalLeadIndex' },
  { label: 'GL NIP Index', field: 'nipGlobalLeadIndex' },
  { label: 'LL NRU Index', field: 'nruLocalLeadIndex' },
  { label: `Sales Revenue (${currency})`, field: 'salesRevenue' },
  { label: 'LP/FMC Factor', field: 'listPriceFmcFactor' },
  { label: 'List Price C&O %', field: 'lpCoIncrease' },
];

type KeyfiguresTableProps = {
  title: string;
  priceListName: string;
  currency: string;
  firstHeader: string;
  columns: KeyfiguresColumn[];
  highlightColor: string;
};

const KeyfiguresTable = ({
  title,
  priceListName,
  currency,
  firstHeader,
  columns,
  highlightColor,
}: KeyfiguresTableProps) => {
  return (
    <Flex direction="column" gap="4px">
      <Table.Container scrollable={false}>
        <Table
          aria-label={`${priceListName} ${title}`}
          size="small"
          className="elevation-md"
        >
          <Table.Header>
            <Table.Row style={{ backgroundColor: 'transparent' }}>
              <Table.HeaderCell
                style={{
                  height: '60px',
                  borderBottom: `1px solid ${themeColors.stroke.muted}`,
                }}
              >
                <span className="label-sm-bold">{firstHeader}</span>
              </Table.HeaderCell>
              {columns.map(({ header, isHighlighted }) => (
                <Table.HeaderCell
                  key={header}
                  width="120px"
                  align="center"
                  style={{
                    height: '60px',
                    backgroundColor: isHighlighted ? highlightColor : undefined,
                    borderBottom: `1px solid ${themeColors.stroke.muted}`,
                  }}
                >
                  <span className="label-sm-bold">{header}</span>
                </Table.HeaderCell>
              ))}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {getKeyFigures(currency).map(({ label, field }) => {
              const borderBottom =
                field === 'nruLocalLeadIndex'
                  ? `1px solid ${connectColors.core.black}`
                  : `1px solid ${themeColors.stroke.muted}`;
              return (
                <Table.Row
                  key={label}
                  style={{ backgroundColor: 'transparent' }}
                >
                  <Table.Cell style={{ borderBottom }}>
                    <span className="label-xs-bold">{label}</span>
                  </Table.Cell>
                  {columns.map(({ header, row, isHighlighted }) => (
                    <Table.Cell
                      key={header}
                      align="right"
                      style={{
                        backgroundColor: isHighlighted
                          ? highlightColor
                          : undefined,
                        borderBottom,
                      }}
                    >
                      <span className="label-xs-regular">
                        {row?.[field] ?? '-'}
                      </span>
                    </Table.Cell>
                  ))}
                </Table.Row>
              );
            })}
            <Table.Row style={{ backgroundColor: 'transparent' }}>
              <Table.Cell />
              {columns.map(({ header, isHighlighted }) => (
                <Table.Cell
                  key={header}
                  style={{
                    height: '24px',
                    padding: '0px',
                    backgroundColor: isHighlighted ? highlightColor : undefined,
                  }}
                />
              ))}
            </Table.Row>
          </Table.Body>
        </Table>
      </Table.Container>
      <Text className="label-sm-regular" color={themeColors.content.subtle}>
        * Dev is the result of Simulation result vs as-is
      </Text>
    </Flex>
  );
};
export default KeyfiguresTable;
